class DatabaseInterfaceController {
    private appContext: any;
    constructor(ctx: any) {
        this.appContext = ctx;
    }
    public Queue(actionMode: string, actionParams: any[]) {
        //add to queue
        this.appContext.databaseActionModeQueueRef.current = this.appContext.databaseActionModeQueueRef.current.concat(actionMode);
        this.appContext.databaseActionParamsQueueRef.current = this.appContext.databaseActionParamsQueueRef.current.concat([actionParams]);
        //update state
        this.appContext.SetDatabaseActionModeQueue([...this.appContext.databaseActionModeQueueRef.current]);
        this.appContext.SetDatabaseActionParamsQueue([...this.appContext.databaseActionParamsQueueRef.current]);
    }
}
export default DatabaseInterfaceController;